<template>
  <div class="elite-tabs-wrapper-content">
    <div class="custom-header">
      <div class="row">
          <div class="col-12 text-right">
              <!--<base-button
                  @click="printAwardCertificates()"
                  type="button"
                  class="elite-button btn-success text-right"
                  v-if="property.is_sold && property.sold_amount"
              >
                <span class="btn-inner--icon mr-1">
                  <i class="fa fa-file"></i>
                </span>
                <span class="btn-inner--text">
                  {{ $t("PROPERTIES_COLLECTIONS.PRINT_AWARD_CERTIFICATE") }}
                </span>
              </base-button>-->
            </div>
        </div>
    </div>
    <h3 class="mb-4">
      {{ property.address }},
      <span class="text-uppercase">
        {{ property.city }} {{ property.state }} </span
      >,
      {{ property.zipcode }}
    </h3>

    <div class="row mb-5">
      <div class="col-12">
        <!--<dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.TAXABLE") }}</dt>
          <dd class="col-sm-8" v-if="property.taxable !== undefined">
            <span v-if="property.taxable">
              {{ $t("COMMON.YES") }}
            </span>
            <span v-else>
              {{ $t("COMMON.NO") }}
            </span>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("PROPERTIES_COLLECTIONS.ACQUISITION_NUMBER") }}</dt>
          <dd class="col-sm-8">
            {{ property.acquisition_number }}
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("PROPERTIES_COLLECTIONS.ACQUISITION_METHODE") }}</dt>
          <dd class="col-sm-8">
            {{ property.acquisition_method }}
          </dd>
        </dl>-->

        <dl class="row">
          <dt class="col-sm-4">{{ $t("PROPERTIES_COLLECTIONS.PROPERTY_NUMBER") }}</dt>
          <dd class="col-sm-8">
            {{ property.property_number }}
          </dd>
        </dl>

        <!--<dl class="row">
          <dt class="col-sm-4">{{ $t("PROPERTIES_COLLECTIONS.DISPLAY_ON_WEB_SITE") }}</dt>
          <dd class="col-sm-8">
            <badge :type="'success'" v-if="property.active">
              {{ $t(`COMMON.YES`) }}
            </badge>
            <badge :type="'danger'" v-else>
              {{ $t(`COMMON.NO`) }}
            </badge>
          </dd>
        </dl>-->

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.STATUS") }}</dt>
          <dd class="col-sm-8" v-if="property.status">
            <property-status-badge-component :property="property" />
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("PROPERTIES_COLLECTIONS.CANCEL_REASON") }}</dt>
          <dd class="col-sm-8" v-if="property?.cancel_reason && property.status == 'CANCEL'">
            {{ property?.cancel_reason ? property?.cancel_reason : property.status == 'CANCEL' && property.total_paied == property.total ? $t("PROPERTIES_COLLECTIONS.DEFAULT_CANCEL_REASON") : '' }}
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("PROPERTIES_COLLECTIONS.APPROVED_AT") }}</dt>
          <dd class="col-sm-8" v-if="property.sale_confirmed_at">
            {{
              $formatDate(property.approved_at, "dddd D MMMM YYYY HH:mm")
            }}
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">
            {{ $t("PROPERTIES.PROPERTIES_TAXES_DUE_SCHOOL") }}
          </dt>
          <dd class="col-sm-8">
            {{ $formatCurrency(property.owed_taxes_school_board) }}
          </dd>
        </dl>

        <dl class="row" v-if="property.taxes_school_board_list && property.taxes_school_board_list.length > 1">
          <dt class="col-sm-12">{{ $t("PROPERTIES.PROPERTIES_TAXES_DUE_SCHOOL_LIST") }}</dt>
          <dd class="col-sm-12">
            <dl class="row" v-for="(tax, key) in property.taxes_school_board_list" :key="key">
              <dt class="col-sm-4">{{ tax.name }}</dt>
              <dd class="col-sm-8">
                {{ $formatCurrency(tax.value) }}
              </dd>
            </dl>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">
            {{ $t("PROPERTIES.PROPERTIES_TAXES_DUE_MUNICIPAL") }}
          </dt>
          <dd class="col-sm-8">
            {{ $formatCurrency(property.owed_taxes_municipality) }}
          </dd>
        </dl>

        <dl class="row" v-if="property.taxable">
          <dt class="col-sm-4">
            {{ $t("PROPERTIES.PROPERTIES_TAXES_DUE_TPS") }}
          </dt>
          <dd class="col-sm-8">
            {{ $formatCurrency(property.taxes_tps) }}
          </dd>
        </dl>

        <dl class="row" v-if="property.taxable">
          <dt class="col-sm-4">
            {{ $t("PROPERTIES.PROPERTIES_TAXES_DUE_TVQ") }}
          </dt>
          <dd class="col-sm-8">
            {{ $formatCurrency(property.taxes_tvq) }}
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("PROPERTIES.PROPERTY_TAX_DUE") }}</dt>
          <dd class="col-sm-8">
            {{ $formatCurrency(property.total_taxes) }}
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("PROPERTIES.APPLICABLES_FEES") }}</dt>
          <dd class="col-sm-8">
            {{ $formatCurrency(property.total_fees) }}
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.SUBTOTAL") }}</dt>
          <dd class="col-sm-8">
            {{ $formatCurrency(property.sub_total) }}
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("PROPERTIES.PAYMENT_RECEIVED") }}</dt>
          <dd class="col-sm-8">
            {{ $formatCurrency(property.total_paied) }}
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("PROPERTIES.PROPERTY_TOTAL_DUE") }}</dt>
          <dd class="col-sm-8">
            {{ $formatCurrency(property.total-property.total_paied) }}
          </dd>
        </dl>

        

        <dl class="row">
          <dt class="col-sm-4">{{ $t("PROPERTIES_COLLECTIONS.REGISTRATION_NUMBER") }}</dt>
          <dd class="col-sm-8">
            {{ property.registration_number }}
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">
            {{ $t("PROPERTIES_COLLECTIONS.INFOS_LINKS") }}
          </dt>
          <dd class="col-sm-8">
            <a :href="line.link" class="info-link-item" target="_blank" v-for="(line, index) in property.infos_links" :key="index">
              <i class="fa fa-link"></i> {{ line.title }}
            </a>
            
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("PROPERTIES_COLLECTIONS.BATCH_NUMBER") }}</dt>
          <dd class="col-sm-8">
            <span v-for="(item, idx) in property.batch_numbers" :key="idx">
              <template>
                {{ `${$numberFormat(item.value)}` }}
                {{ property.batch_numbers.length - 1 > idx ? ", " : " " }}
              </template>
            </span>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("PROPERTIES_COLLECTIONS.TYPE") }}</dt>
          <dd class="col-sm-8">
            <span>
              {{
                property.property_type && property.property_type != "" ? $t(`PROPERTIES.PROPERTIES_TYPE_LONG_${property.property_type}`) : "-"
              }}
            </span>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("PROPERTIES_COLLECTIONS.REGISTRATION_DIVISION") }}</dt>
          <dd class="col-sm-8 text-uppercase">
            <div>{{ property.registrationDivision?.name }}</div>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("PROPERTIES_COLLECTIONS.REFERENCE_CSS") }}</dt>
          <dd class="col-sm-8">
            <div>{{ property.reference_css }}</div>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("PROPERTIES_COLLECTIONS.ORIGIN") }}</dt>
          <dd class="col-sm-8">
            <div>{{ property.origin && property.origin != "" ? $t(`PROPERTIES.PROPERTIES_ORIGIN_${property.origin}`) : "-" }}</div>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.ADDRESS") }}</dt>
          <dd class="col-sm-8 text-uppercase">
            <div v-html="property.address"></div>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.CITY") }}</dt>
          <dd class="col-sm-8 text-uppercase">
            <div v-html="property.city"></div>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.ZIPCODE") }}</dt>
          <dd class="col-sm-8">
            <div v-html="property.zipcode"></div>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.STATE") }}</dt>
          <dd class="col-sm-8 text-uppercase">
            <div v-html="property.state"></div>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.COUNTRY") }}</dt>
          <dd class="col-sm-8 text-uppercase">
            <div v-html="property.country"></div>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("PROPERTIES_COLLECTIONS.DESIGNATION") }}</dt>
          <dd class="col-sm-8">
            {{ property.designation_translate.fr ? property.designation_translate.fr : property.designation }}
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.NOTE") }}</dt>
          <dd class="col-sm-8">
            <div v-html="property.excerpt"></div>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.CREATED_BY") }}</dt>
          <dd class="col-sm-8">
            <users :users="[property.createdBy]" />
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.UPDATED_BY") }}</dt>
          <dd class="col-sm-8">
            <users :users="[property.updatedBy]" />
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.LOCATIONS") }}</dt>
          <dd class="col-sm-8">
            <locations :locations="property.allowedLocations" />
          </dd>
        </dl>

        <dl class="row" v-if="0">
          <dt class="col-sm-4">{{ $t("COMMON.OWNERS") }}</dt>
          <dd class="col-sm-8">
            <contacts :contacts="property.owners" />
          </dd>
        </dl>

        <dl
          class="row"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)"
        >
          <dt class="col-sm-4">{{ $t("COMMON.ORGANIZATION") }}</dt>
          <dd class="col-sm-8">
            <organization :organization="property.organization" />
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.CREATED_AT") }}</dt>
          <dd class="col-sm-8">
            {{ $formatDate(property.created_at) }}
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.UPDATED_AT") }}</dt>
          <dd class="col-sm-8">
            {{ $formatDate(property.updated_at) }}
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import { TAX_TYPE_AMOUNT, TAX_TYPE_PERCENTAGE } from "@/constants/taxes";
import Users from "@/components/Users.vue";
import Contacts from "@/components/Contacts.vue";
import PropertyStatusBadgeComponent from "../components/PropertyStatusBadgeComponent";
import swal from "sweetalert2";
import moment from "moment";

export default {
  name: "property-view-global",

  props: ["property"],

  components: {
    Users,
    Contacts,
    PropertyStatusBadgeComponent,
  },

  data() {
    return { 
      TAX_TYPE_PERCENTAGE,
      TAX_TYPE_AMOUNT,
      bidStartingAmount : 0,
    };
  },

  computed: {},

  created() {
    console.log(this.property);
  },

  methods: {
    formatDate(dateString) {
      // Extraire uniquement la partie yyyy-mm-dd
      const [year, month, day] = dateString.split('T')[0].split('-');
      const date = new Date(year, month - 1, day); // Crée une date locale
      return new Intl.DateTimeFormat('fr-FR', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }).format(date);
    },
    propertyUpdated() {
      this.$emit("propertyUpdated", true);
    },
  },

  mounted() {
    let totalOtherFees = 0;
    let totalDue = this.property.total-this.property.total_paied;
    if(this.property?.other_fees?.length){
        totalOtherFees = this.property.other_fees.reduce((sum, fee) => {
          return sum + (parseFloat(fee.calculated_amount) || 0);
        }, 0);
        this.bidStartingAmount = parseFloat(totalDue) + parseFloat(totalOtherFees);
    }
  },

  watch: {
    property(property) {},
  },
};
</script>
<style lang="scss" scoped>
  .info-link-item{
    background-color: #dceeec;
    padding: 5px;
    margin: 5px;
    border: 1px solid #5ca4c8;
    border-radius: 11px;
  }
</style>
